import React from 'react';

const Footer = () => (
  <footer>
    <div className="redesS">
      <a href="https://www.facebook.com/?locale=es_LA">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/0/05/Facebook_Logo_%282019%29.png/768px-Facebook_Logo_%282019%29.png" alt="redes" className="redes" />
      </a>
      <a href="https://www.instagram.com/">
        <img src="https://upload.wikimedia.org/wikipedia/commons/thumb/a/a5/Instagram_icon.png/2048px-Instagram_icon.png" alt="redes" className="redes" />
      </a>
      <a href="https://x.com/?lang=es">
        <img src="https://freelogopng.com/images/all_img/1690643640twitter-x-icon-png.png" alt="redes" className="redes" />
      </a>
    </div>
    <p>Derechos reservardos a luis.ramos02@epn.edu.ec - Proyecto Front End</p>
    <p>Quito - Ecuador</p>
  </footer>
);

export default Footer;
